<template>
  <LSButton type="highlight" variant="outline" class="rounded-full h-8 w-8" @click="addClause">
    <template #icon>
      <PlusIcon />
    </template>
  </LSButton>
  <EditClauseModal :show="isOpen" :section="section" @close="close" @submit="handleSubmit"></EditClauseModal>
</template>

<script setup lang="ts">
import LSButton from '@/components/LSButton.vue'
import { useLegalDocumentTemplateStore } from '@/questionnaire/stores/legalDocumentTemplate'
import useEditClause from '@/utils/useEditClause'
import { computed } from 'vue'
import EditClauseModal from './EditClauseModal.vue'
import PlusIcon from '@/assets/icons/24/plus.svg?component'

const props = defineProps<{
  code: string
  text: string
  optional: boolean
}>()
const legalDocumentTemplateStore = useLegalDocumentTemplateStore()
const section = computed(() => legalDocumentTemplateStore.sections[props.code])
const { addClause, close, handleSubmit, isOpen } = useEditClause(section.value)
</script>
